/* eslint-disable */
const localization = {
    // This is the array of lexemes found in the app
    lexemes: [
      "मेरी व्यक्तिगत जानकारी को न बेचें और न ही साझा करें",
      "Bumble डेट",
      "हमारे ऐप्स",
      "हमारे बारे में",
      "करियर",
      "हमसे संपर्क करें",
      "निवेशक",
      "शॉप",
      "कंपनी",
      "ऐप को डाउनलोड करें",
      "Bumble पर ऐक्सेसबिलिटी",
      "दिशानिर्देश",
      "कुकीज़ प्रबंधित करें",
      "मॉडर्न स्लेवरी एक्ट",
      "संग्रह पर सूचना",
      "प्राइवेसी पॉलिसी",
      "नियम और शर्तें",
      "कानूनी",
      "वाशिंगटन कंज्यूमर हैल्थ प्राइवेसी पॉलिसी",
      "Bumble ऐप प्राप्त करने के लिए QR कोड स्कैन करें",
      "यहाँ कान्ट्रैक्ट समाप्त करें",
      "मेनू बंद करें",
      "मेनू खोलें",
      "भाषा चुनें",
      "फूटर",
      "Bumble पर ऐक्सेसबिलिटी\n\n---",
      "Apple और Apple का लोगो Apple Inc के ट्रेडमार्क हैं।",
      "Bumble BFF",
      "Bumble Bizz",
      "Bumble डेट",
      "करियर",
      "Google Play, Google LLC का ट्रेडमार्क है.",
      "दिशानिर्देश",
      "निवेशक",
      "कुकीज़ प्रबंधित करें",
      "Modern Slavery Act स्टेटमेंट",
      "संग्रह पर सूचना",
      "गोपनीयता नीति",
      "सीजनल डेटिंग गाइड्स",
      "नियम और शर्तें",
      "ऐप",
      "वाशिंगटन कंज्यूमर हैल्थ डाटा प्राइवेसी पॉलिसी",
      "हमारे बारे में",
      "एम्बेसडर",
      "नये दोस्त बनाएं और अपनी कम्यूनिटी को खोजें",
      "पेशेवर रूप से नेटवर्क बनाएं और करियर में आगे बढ़ें",
      "कोई रिश्ता, कुछ अनौपचारिक, या बीच का कुछ भी खोजें",
      "The Buzz",
      "और जानिये",
      "ट्रेवल मोड के ग्लोबल हो जाएं",
      "Date",
      "फीचर्स",
      "Compliments",
      "उन्हें कुछ Compliments दें ताकि आप भीड़ से अलग दिखें।",
      "खोज",
      "एक व्यक्तिगत पेज जो आपके लिए सबसे अनुकूल लोगों को हाइलाइट करता है, हर रोज़ रिफ्रेश किया जाता है",
      "गुप्त मोड",
      "अपने बॉस, रिश्तेदारों या पूर्व साथियों से अपनी प्रोफ़ाइल छिपाने के लिए गुप्त मोड का उपयोग करें।",
      "तुरंत मैच",
      "क्या आपने Bumble के असल जीवन के इवेंट में बातचीत शुरू की है? इसे ऐप पर जारी रखें।",
      "Opening Moves",
      "चैट शुरू करने के लिए अपने मैच को आमंत्रित करने के लिए Opening Moves चुनें, ताकि आपको मेहनत ना करनी पड़े।",
      "स्नूज़ मोड",
      "स्नूज़ मोड के साथ डेटिंग को होल्ड पर रखें। जब आप फिर से डेट करने के लिए तैयार हों, आपको पता ही है कि हम कहाँ हैं।",
      "SuperSwipe",
      "प्रोफ़ाइल वाइब जांच में पास हुई? SuperSwipe से उन्हें बताएं।",
      "ट्रैवल",
      "ट्रैवल के साथ दुनिया में कहीं भी अपना ड्यूटी-फ्री स्नैक और मैच ढूंढें।",
      "वीडियो चैट",
      "क्या आप किसी से व्यक्तिगत तौर पर मिलने के लिए तैयार है यह देखने के लिए वीडियो चैट और ऑडियो कॉल का उपयोग करें।",
      "वेब ऐप",
      "सीधे अपने ब्राउज़र पर Bumble अनुभव प्राप्त करें।",
      "Bumble ऐप प्राप्त करें",
      "BFF",
      "सुरक्षा",
      "कहानियाँ",
      "सहायता",
      "शॉप",
      "मुख्य",
      "उन्हें कुछ Compliments दें ताकि आप भीड़ से अलग दिखें।",
      "Compliments",
      "ऐसे फीचर जो सच्चे, सम्मानजनक और सार्थक रिश्तों के लिए जगह बनाने के उद्देश्य से तैयार किए गए हैं।",
      "अपने बॉस, रिश्तेदारों या पूर्व साथियों से अपनी प्रोफ़ाइल छिपाएं।",
      "गुप्त मोड",
      "स्नूज़ मोड के साथ डेटिंग को होल्ड पर रखें।",
      "स्नूज़ मोड",
      "कोई पसंद का व्यक्ति दिखा? उन्हें बताएं।",
      "SuperSwipe",
      "Date को एक्सप्लोर करें",
      "अपना ड्यूटी-फ्री स्नैक और मैच कहीं भी पाएं।",
      "ट्रैवल",
      "अपना घर छोड़े बिना असल ज़िंदगी में करीब पहुंचें।",
      "वीडियो कॉलस",
      "हमारे लीडर Bumble की मान्यताओं को देश भर के समुदायों में लाने में सहायता करते हैं।",
      "कम्यूनिटी के लीडर",
      "ऐसे फीचर जो आपको अपने जैसे लोगों को ढूँढने और अपनी पसंद की चीज़ों पर जुड़ने में मदद करते हैं।",
      "एक ग्रुप मीटअप आयोजित करें, या आस-पास की स्थानीय इवेंट्स को खोजें।",
      "Plans",
      "BFF को एक्सप्लोर करें",
      "आपको प्यार और दोस्ती पाने में मदद करने के लिए सभी आवश्यक मार्गदर्शन और प्रेरणा।",
      "मनचाही दोस्ती पाने में आपकी मदद करने के लिए सलाह और कहानियाँ।",
      "फ्रेंडशिप हब",
      "टोक्यो से टोरोन्टो टक, दुनिया भर में Bumble पर प्यार ढूंढें।",
      "प्रेम कहानियाँ",
      "परफेक्ट डेट प्लान करें—इससे कोई फर्क नहीं पड़ता कि आप कब, कहां या किसके साथ डेटिंग कर रहे हैं।",
      "सीजनल डेटिंग गाइड्स",
      "कहानियाँ एक्सप्लोर करें",
      "और पढ़ें",
      "{{social_network}} पर Bumble",
      "हमसे संपर्क करें",
      "साइन इन करें",
      "(opens in new window)",
      "अक्सर पूछे जाने वाले सवाल",
      "Cookie Policy",
      "Bumble - The Blog",
      "नौकरी",
      "चैट",
      "शहर",
      "कुकी मैनेज करें",
      "Copyright © 2006 – present. Bumble. सभी अधिकार सुरक्षित हैं.",
      "डेटिंग कॉन्फ़िडेंस रिपोर्ट",
      "Apple और Apple का लोगो Apple Inc के ट्रेडमार्क हैं.{{__EOL__}}Google Play, Google LLC का ट्रेडमार्क है.",
      "डाउनलोड करें",
      "Facebook",
      "हमें फ़ॉलो करें",
      "सहायता केंद्र",
      "Instagram",
      "भाषा",
      "LinkedIn",
      "Bumble, Bumble Inc का हिस्सा है.",
      "निजता नीति",
      "सुरक्षा केंद्र",
      "साइटमैप",
      "मॉडर्न स्लेवरी ऐक्ट स्टेटमेंट",
      "नियम और शर्तें",
      "Twitter"
],

    // These are the common words found in the lexemes of the app
    common: {
      "day": {
            "plural": [
                  "दिन",
                  "दिनों"
            ],
            "singular": [
                  "दिन",
                  "दिन"
            ]
      },
      "hour": {
            "plural": [
                  "घंटे",
                  "घंटे"
            ],
            "singular": [
                  "घंटे",
                  "घंटे"
            ]
      },
      "minute": {
            "plural": [
                  "मिनट",
                  "मिनटों"
            ],
            "singular": [
                  "मिनट",
                  "मिनट"
            ]
      },
      "month": {
            "plural": [
                  "महीने",
                  "महीनों"
            ],
            "singular": [
                  "महीना",
                  "महीना"
            ]
      },
      "second": {
            "plural": [
                  "सेकंड",
                  "सेकंड"
            ],
            "singular": [
                  "सेकंड",
                  "सेकंड"
            ]
      },
      "year": {
            "plural": [
                  "साल",
                  "सालों"
            ],
            "singular": [
                  "साल",
                  "साल"
            ]
      }
}
};

// In dev mode we extend lexemes to include the indexMap as well, in production it remains as an array
if (__DEV__) {
    // This is a map of lexeme ids to their index in the array, it's only needed during development
    const indexMap = require('./index-map').default;

    localization.indexMap = indexMap;

    Object.entries(localization.indexMap).forEach(([indexKey, indexValue]) => {
        localization.lexemes[indexKey] = localization.lexemes[indexValue];
    });
}

export default localization;
